// extracted by mini-css-extract-plugin
export default {"Card":"conversation-tree_Card__JpJ5m"};